<template>
  <div style="width: 100% !important;">
    <v-autocomplete
      :value="selected"
      @input="select"
      :items="additional"
      :label="label"
      item-text="title"
      item-value="id"
      :return-object="returnObject"
      :clearable="clearable"
      :hide-selected="hideSelected"
      clear-icon="mdi-broom"
      prepend-inner-icon="mdi-close-circle"
      @click:prepend-inner="$emit('closed', true)"
      :class="{ 'hide-chips': hideChips, 'additional-autocomplete': true }"
      autocomplete="off"
      filled
      chips
      multiple
      hide-details
      hide-no-data
    >
      <template v-slot:selection="{ item, selected }">
        <v-chip
          v-if="!hideChips"
          :input-value="selected"
          close
          @click:close="remove(item)"
          class="additional-chip chip--select-multi"
        >
          <div v-if="!hideQty" class="qty-block" @click.stop="() => null">
            <v-icon
              @click.stop="inc(item)"
              dense
              x-small
            >
              mdi-menu-up
            </v-icon>
            <div class="qty-counter">{{ item.qty }}</div>
            <v-icon
              @click.stop="dec(item)"
              dense
              x-small
            >
              mdi-menu-down
            </v-icon>
          </div>
          <span class="adt-title">
            {{ `x${getQty(item.id)} ${item.title} (${formatCurrency(item.price)})` }}
          </span>
          <v-divider
            class="adt-divider"
            light
          ></v-divider>
          <span class="total">{{ getTotal(item.id) }}</span>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ formatCurrency(item.price) }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    dialog: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    hideChips: {
      type: Boolean,
      default: false
    },
    hideQty: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    hideSelected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: (this.value ? [ ...this.value ] : [])
    }
  },
  computed: {
    additional: {
      get () {
        let result = []
        const adtAssign = (price) => ({
          qty: 1,
          total: price
        })
        this.items.forEach((value) => {
          value = Object.assign({ ...value }, { ...adtAssign(value.price) })
          result.push({ ...value })
        })
        return [ ...result ]
      },
      set () {
        /* */
      }
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.value) !== JSON.stringify(newVal)) this.$emit('input', [ ...this.selected ])
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal)) this.selected = [ ...this.value ]
      }
    }
  },
  methods: {
    getQty (id) {
      const obj = this.selected.find(el => el.id === id)
      return obj.qty || 1
    },
    getTotal (id) {
      const obj = this.selected.find(el => el.id === id) || 1
      return this.formatCurrency(obj.total)
    },
    select (items) {
      console.log('select', items)
      this.$set(this, 'selected', [ ...items ])
    },
    inc (item) {
      const obj = this.selected.find(el => el.id === item.id)
      console.log('inc', item)
      item.qty++
      obj.qty++
      console.log('this.selected', this.selected)
      this.$emit('input', this.selected)
    },
    dec (item) {
      const obj = this.selected.find(el => el.id === item.id)
      console.log('dec', item)
      if (obj.qty < 2) {
        this.remove(item)
      } else {
        item.qty--
        obj.qty--
      }
      console.log('this.selected', this.selected)
      this.$emit('input', this.selected)
    },
    remove (item) {
      const obj = (this.returnObject ? this.selected.find(el => el.id === item.id) : this.selected.find(el => el === item.id))
      const index = this.selected.indexOf(obj)
      if (index >= 0) this.selected.splice(index, 1)
    }
  }
}
</script>

<style src="../../../styles/autocomplete.scss" lang="scss"></style>
<style lang="scss">
.additional-autocomplete {
  #app & {
    .v-input__control .v-input__slot {
      padding: 0 7px !important;
      .v-select__slot {
        .v-input__prepend-inner {
          margin-right: auto;
          padding-right: 7px;
        }
        .v-input__append-inner {
          margin-top: 3px !important;
          transition: all 0.4s ease 0s !important;
        }
        label {
          transition: all 0.4s ease 0s !important;
        }
        .v-select__selections {
          min-height: 57px !important;
          .additional-chip {
            width: 99%;
            height: 27px;
            margin-bottom: 0px;
            .qty-block {
              width: 17px;
              position: relative;
              .qty-counter {
                font-size: 11px !important;
                position: relative;
                top: -10px;
                left: 1px;
                display: none;
              }
              .v-icon {
                font-size: 32px !important;
                width: 15px !important;
                height: 13px !important;
                &.mdi-menu-down {
                  font-size: 33.4px !important;
                  position: absolute;
                  bottom: -12px;
                  left: -2px;
                }
                &.mdi-menu-up {
                  font-size: 32.2px !important;
                  position: absolute;
                  top: -12px;
                  left: -2px;
                }
                &:before {
                  pointer-events: none;
                }
              }
            }
            .adt-title {
              font-size: 12px;
              width: auto;
              max-width: 150px !important;
              margin: 0px !important;
              padding: 0px 4px 0px 4px !important;
              overflow: hidden;
              white-space: nowrap;
              position: relative;
              text-overflow: ellipsis;
              transition: all 0.3s ease-in-out;
              border-radius: 3px;
              &:hover {
                max-width: 100% !important;
                position: absolute !important;
                left: 26px;
                z-index: 1 !important;
              }
            }
            .adt-divider {
              position: absolute;
              top: 14px;
              right: 24%;
              width: 45%;
              background: transparent !important;
            }
            .total {
              position: absolute;
              top: 3.5px;
              right: 39px;
            }
            .v-icon.mdi-close-circle {
              position: absolute;
              right: 15px;
            }
          }
        }
      }
    }
    &:not(.v-input--is-dirty) {
      .v-input__control {
        .v-input__slot {
          max-height: 32px !important;
          .v-input__append-inner {
            margin-top: 15px !important;
          }
        }
        .v-select__slot {
          label {
            top: 17.9px;
          }
          .v-select__selections input {
            margin-top: 0px;
          }
        }
      }
    }
    &:not(.v-input--is-focused) {
      .v-input__control {
        .v-select__selections:first-of-type input {
          max-height: 0px;
          padding: 0px;
        }
      }
    }
    &.v-input--is-focused {
      .v-select__slot {
        label {
          top: 14px !important;
        }
      }
    }
  }
  #app.theme--light & {
    .v-input__control .v-select__slot .v-select__selections {
      .additional-chip {
        .adt-title:hover {
          background: rgba(255, 255, 255, 0.9) !important;
        }
      }
    }
  }
  #app.theme--dark & {
    .v-input__control .v-select__slot .v-select__selections {
      .additional-chip {
        .adt-title:hover {
          background: rgba(0, 0, 0, 0.7) !important;
        }
      }
    }
  }
}
</style>
